import { UserX, CalendarX, PhoneOff, Users, TrendingDown, BarChart3 } from "lucide-react";
import { Reveal, SectionTag } from "./motion";

const PROBLEMS = [
  {
    icon: UserX,
    title: "Leads sem atendimento",
    text: "Oportunidades chegam todos os dias e esfriam em minutos sem uma resposta rápida e qualificada.",
  },
  {
    icon: CalendarX,
    title: "Agendamentos que não comparecem",
    text: "Sem confirmação ativa e régua de relacionamento, o no-show corrói a agenda e o faturamento.",
  },
  {
    icon: PhoneOff,
    title: "Falta de follow-up",
    text: "Pacientes que demonstraram interesse nunca mais são contatados — e fecham com o concorrente.",
  },
  {
    icon: Users,
    title: "Equipes sem treinamento",
    text: "Recepção e comercial sem script, sem processo e sem cultura de conversão de oportunidades.",
  },
  {
    icon: TrendingDown,
    title: "Vendas perdidas",
    text: "O marketing gera demanda, mas a operação não converte. O investimento vira custo, não retorno.",
  },
  {
    icon: BarChart3,
    title: "Ausência de indicadores",
    text: "Sem dados, ninguém sabe onde a clínica perde dinheiro — nem o que fazer para crescer.",
  },
];

export default function Problems() {
  return (
    <section id="problemas" data-testid="problems-section" className="bg-bone text-graphite py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <SectionTag dark={false}>O diagnóstico</SectionTag>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-ink leading-[1.12]" data-testid="problems-title">
              O problema não é só gerar leads.{" "}
              <span className="text-gold-deep">É o que acontece depois deles.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-base sm:text-lg text-graphite/70 leading-relaxed">
              A maioria das clínicas investe em anúncios e trava no mesmo lugar: uma operação
              comercial que não estava pronta para transformar interesse em receita.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p.title} delay={0.08 * i} data-testid={`problem-card-${i}`}>
              <div className="group h-full bg-white rounded-2xl p-8 border border-graphite/10 hover:border-gold hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-24px_rgba(212,156,36,0.35)] transition-[transform,border-color,box-shadow] duration-500">
                <div className="w-12 h-12 rounded-xl bg-ink flex items-center justify-center group-hover:bg-gold transition-colors duration-500">
                  <p.icon size={22} className="text-gold group-hover:text-ink transition-colors duration-500" />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl text-ink tracking-tight">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-graphite/70">{p.text}</p>
                <span className="mt-6 block h-0.5 w-10 bg-gold/40 group-hover:w-full transition-[width] duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
